// import React, { useState, useEffect } from 'react';
// import { initializeApp } from 'firebase/app';
// import { 
//   getAuth, 
//   GoogleAuthProvider, 
//   signInWithPopup, 
//   signOut, 
//   onAuthStateChanged 
// } from 'firebase/auth';

// // Firebase Configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyCuOGfEavfiGpvOu6Gz3r2i_SgOE_gcTOw",
//   authDomain: "raizeit-771e5.firebaseapp.com",
//   projectId: "raizeit-771e5",
//   storageBucket: "raizeit-771e5.firebasestorage.app",
//   messagingSenderId: "467814664892",
//   appId: "1:467814664892:web:8f28785aaa1660df7adeb9",
//   measurementId: "G-CPJVRFF499"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);
// const provider = new GoogleAuthProvider();

// const AuthComponent = () => {
//   const [user, setUser] = useState(null);
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isSigningIn, setIsSigningIn] = useState(false);

//   // Authentication Functions
//   const handleSignIn = async () => {
//     setIsSigningIn(true);
    
//     try {
//       const result = await signInWithPopup(auth, provider);
//       console.log('✅ User signed in:', result.user.email);
//       setIsModalOpen(false);
//     } catch (error) {
//       console.error('❌ Sign-in error:', error);
//       alert('Failed to sign in. Please try again.');
//     } finally {
//       setIsSigningIn(false);
//     }
//   };

//   const handleSignOut = async () => {
//     try {
//       await signOut(auth);
//       console.log('👋 User signed out');
//       setIsDropdownOpen(false);
//     } catch (error) {
//       console.error('❌ Sign-out error:', error);
//     }
//   };

//   const requireAuth = (callback) => {
//     if (!user) {
//       setIsModalOpen(true);
//     } else {
//       callback();
//     }
//   };

//   // Firebase Auth State Observer
//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
//       console.log('🔄 Auth state changed:', currentUser ? currentUser.email : 'No user');
//       setUser(currentUser);
      
//       // Store user globally if needed
//       window.currentUser = currentUser;
//       window.firebaseAuthUser = currentUser;
//     });

//     return () => unsubscribe();
//   }, []);

//   // Show modal on first visit
//   useEffect(() => {
//     if (!user) {
//       const timer = setTimeout(() => {
//         setIsModalOpen(true);
//       }, 2000);
      
//       return () => clearTimeout(timer);
//     }
//   }, [user]);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = () => setIsDropdownOpen(false);
    
//     if (isDropdownOpen) {
//       document.addEventListener('click', handleClickOutside);
//     }
    
//     return () => document.removeEventListener('click', handleClickOutside);
//   }, [isDropdownOpen]);

//   // Get user initial
//   const getUserInitial = () => {
//     if (!user) return '👤';
//     const displayName = user.displayName || user.email.split('@')[0];
//     return displayName.charAt(0).toUpperCase();
//   };

//   // Get profile icon background
//   const getProfileBackground = () => {
//     return user 
//       ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
//       : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
//   };

//   return (
//     <>
//       {/* Profile Menu */}
//       <div className="profile-menu">
//         <div 
//           id="profileIcon"
//           className="profile-icon"
//           style={{ background: getProfileBackground() }}
//           onClick={(e) => {
//             e.stopPropagation();
//             setIsDropdownOpen(!isDropdownOpen);
//           }}
//         >
//           {getUserInitial()}
//         </div>

//         {/* Dropdown Menu */}
//         <div 
//           id="dropdownMenu"
//           className={`dropdown ${isDropdownOpen ? 'show' : ''}`}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <ul>
//             <li>
//               <a href="#" onClick={(e) => {
//                 e.preventDefault();
//                 requireAuth(() => window.location.href = '/app');
//               }}>
//                 Submit Issue
//               </a>
//             </li>
//             <li>
//               <a href="#" onClick={(e) => {
//                 e.preventDefault();
//                 if (user) {
//                   handleSignOut();
//                 } else {
//                   setIsDropdownOpen(false);
//                   setIsModalOpen(true);
//                 }
//               }}>
//                 {user ? 'Sign Out' : 'Sign In'}
//               </a>
//             </li>
//           </ul>
//         </div>
//       </div>

//       {/* Sign In Modal */}
//       {isModalOpen && (
//         <div 
//           id="signinModal"
//           className="modal-overlay"
//           onClick={(e) => {
//             if (e.target.classList.contains('modal-overlay')) {
//               setIsModalOpen(false);
//             }
//           }}
//         >
//           <div className="modal-content">
//             <button 
//               className="modal-close-btn"
//               onClick={() => setIsModalOpen(false)}
//             >
//               ✕
//             </button>
            
//             <h2>Welcome to RaizeIt</h2>
//             <p>Sign in to submit issues and track your reports</p>
            
//             <button 
//               className="btn btn--primary"
//               onClick={handleSignIn}
//               disabled={isSigningIn}
//             >
//               {isSigningIn ? 'Signing in...' : 'Sign in with Google'}
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default AuthComponent;

// // Export helper functions
// export const getCurrentUser = () => auth.currentUser;
// export { auth };




import React, { useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup, 
  signOut, 
  onAuthStateChanged 
} from 'firebase/auth';

// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyCuOGfEavfiGpvOu6Gz3r2i_SgOE_gcTOw",
  authDomain: "raizeit-771e5.firebaseapp.com",
  projectId: "raizeit-771e5",
  storageBucket: "raizeit-771e5.firebasestorage.app",
  messagingSenderId: "467814664892",
  appId: "1:467814664892:web:8f28785aaa1660df7adeb9",
  measurementId: "G-CPJVRFF499"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

const AuthComponent = () => {
  const [user, setUser] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSigningIn, setIsSigningIn] = useState(false);

  // Authentication Functions
  const handleSignIn = async () => {
    setIsSigningIn(true);
    
    try {
      const result = await signInWithPopup(auth, provider);
      console.log('✅ User signed in:', result.user.email);
      setIsModalOpen(false);
    } catch (error) {
      console.error('❌ Sign-in error:', error);
      
      // Better error messages
      if (error.code === 'auth/configuration-not-found') {
        alert('Firebase Authentication is not configured. Please enable Google Sign-In in Firebase Console.');
      } else if (error.code === 'auth/popup-closed-by-user') {
        // User closed popup - no alert needed
        console.log('Sign-in popup closed by user');
      } else {
        alert('Failed to sign in. Please try again.');
      }
    } finally {
      setIsSigningIn(false);
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      console.log('👋 User signed out');
      setIsDropdownOpen(false);
    } catch (error) {
      console.error('❌ Sign-out error:', error);
    }
  };

  const requireAuth = (callback) => {
    if (!user) {
      setIsModalOpen(true);
    } else {
      callback();
    }
  };

  // Firebase Auth State Observer
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      console.log('🔄 Auth state changed:', currentUser ? currentUser.email : 'No user');
      setUser(currentUser);
      
      // Store user globally if needed
      window.currentUser = currentUser;
      window.firebaseAuthUser = currentUser;
    });

    return () => unsubscribe();
  }, []);

  // ✅ REMOVED: Auto-show modal on first visit
  // Users will click profile icon to sign in

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = () => setIsDropdownOpen(false);
    
    if (isDropdownOpen) {
      document.addEventListener('click', handleClickOutside);
    }
    
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isDropdownOpen]);

  // Get user initial
  const getUserInitial = () => {
    if (!user) return '👤';
    const displayName = user.displayName || user.email.split('@')[0];
    return displayName.charAt(0).toUpperCase();
  };

  // Get profile icon background
  const getProfileBackground = () => {
    return user 
      ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
      : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
  };

  return (
    <>
      {/* Profile Menu */}
      <div className="profile-menu">
        <div 
          id="profileIcon"
          className="profile-icon"
          style={{ background: getProfileBackground() }}
          onClick={(e) => {
            e.stopPropagation();
            setIsDropdownOpen(!isDropdownOpen);
          }}
        >
          {getUserInitial()}
        </div>

        {/* Dropdown Menu */}
        <div 
          id="dropdownMenu"
          className={`dropdown ${isDropdownOpen ? 'show' : ''}`}
          onClick={(e) => e.stopPropagation()}
        >
          <ul>
            <li>
              <a href="#" onClick={(e) => {
                e.preventDefault();
                requireAuth(() => window.location.href = '/app');
              }}>
                Submit Issue
              </a>
            </li>
            <li>
              <a href="#" onClick={(e) => {
                e.preventDefault();
                if (user) {
                  handleSignOut();
                } else {
                  setIsDropdownOpen(false);
                  setIsModalOpen(true);
                }
              }}>
                {user ? 'Sign Out' : 'Sign In'}
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Sign In Modal - Simplified */}
      {isModalOpen && (
        <div 
          id="signinModal"
          className="modal-overlay"
          onClick={(e) => {
            if (e.target.classList.contains('modal-overlay')) {
              setIsModalOpen(false);
            }
          }}
        >
          <div className="modal-content-simple">
            <button 
              className="modal-close-btn"
              onClick={() => setIsModalOpen(false)}
            >
              ✕
            </button>
            
            {/* ✅ REMOVED: Welcome message and description */}
            {/* Now shows only the sign-in button */}
            
            <button 
              className="btn btn--google-signin"
              onClick={handleSignIn}
              disabled={isSigningIn}
            >
              {isSigningIn ? (
                <>
                  <span className="spinner"></span>
                  Signing in...
                </>
              ) : (
                <>
                  <svg className="google-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                  Sign in with Google
                </>
              )}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AuthComponent;

// Export helper functions
export const getCurrentUser = () => auth.currentUser;
export { auth };
